import { render } from "./TalkTicketScreen.vue?vue&type=template&id=43869fcd&scoped=true&ts=true&lang=pug"
import script from "./TalkTicketScreen.vue?vue&type=script&lang=ts"
export * from "./TalkTicketScreen.vue?vue&type=script&lang=ts"

import "./TalkTicketScreen.vue?vue&type=style&index=0&id=43869fcd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43869fcd"]])

export default __exports__